import type { LucideIcon } from 'lucide-react';
import styles from './CategoryIcon.module.css';

interface CategoryIconProps {
  icon: LucideIcon;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const ICON_SIZES: Record<string, number> = {
  sm: 16,
  md: 22,
  lg: 28,
  xl: 36,
};

export function CategoryIcon({ icon: Icon, size = 'md', className }: CategoryIconProps) {
  return (
    <div className={`${styles.circle} ${styles[size]}${className ? ` ${className}` : ''}`}>
      <Icon size={ICON_SIZES[size]} strokeWidth={1.75} />
    </div>
  );
}
